export enum FeatureFlag {
    ADDRESS_ADDITIONAL_INFORMATION = 'ADDRESS_ADDITIONAL_INFORMATION',
    IMPORTATION_DATE_CONFIGURATION = 'IMPORTATION_DATE_CONFIGURATION',
    AI_CHAT_ENABLED = 'AI_CHAT_ENABLED',
    AI_CHAT_DEMO_PLACEHOLDER_DEFAULTS = 'AI_CHAT_DEMO_PLACEHOLDER_DEFAULTS',
    AI_CHAT_MOBILE_DEFAULT = 'AI_CHAT_MOBILE_DEFAULT',
    BASE_CURRENCY_CONVERSION_DATE_CONTROL = 'BASE_CURRENCY_CONVERSION_DATE_CONTROL',
    CASE_ASSIGNMENT_ENABLED = 'CASE_ASSIGNMENT_ENABLED',
    DELEGATION = 'DELEGATION',
    CASE_OFFICIAL_REF_NUMBER_FIELD = 'CASE_OFFICIAL_REF_NUMBER_FIELD',
    CASE_PAYMENT_CURRENCY_FIELD = 'CASE_PAYMENT_CURRENCY_FIELD',
    COMPLIANCE_PROHIBITS_INVOICE_FINALIZATION = 'COMPLIANCE_PROHIBITS_INVOICE_FINALIZATION',
    DMS_TEAM_AD_INTEGRATION_ENABLED = 'DMS_TEAM_AD_INTEGRATION_ENABLED',
    DOWNLOAD_CONTRACT_TEMPLATE = 'DOWNLOAD_CONTRACT_TEMPLATE',
    EDIT_INVOICE_ACCOUNTING_TYPE = 'EDIT_INVOICE_ACCOUNTING_TYPE',
    EDIT_INVOICE_VAT_CALCULATION_TYPE = 'EDIT_INVOICE_VAT_CALCULATION_TYPE',
    ENABLE_ONBOARDING_AI_ASSISTANT = 'ENABLE_ONBOARDING_AI_ASSISTANT',
    EMPLOYEE_VAT_REG_NUM = 'EMPLOYEE_VAT_REG_NUM',
    HIDE_TIMECARD_EXPENSE_FROM_INVOICE = 'HIDE_TIMECARD_EXPENSE_FROM_INVOICE',
    INVOICE_COPYING_ENABLED = 'INVOICE_COPYING_ENABLED',
    INVOICE_SHARED_PAYMENT_FUNCTIONALITY = 'INVOICE_SHARED_PAYMENT_FUNCTIONALITY',
    LINK_DRAFT_CONTRACTS_WITH_CASES = 'LINK_DRAFT_CONTRACTS_WITH_CASES',
    INVOICE_DETAILS_SHOW_TIMECARD_FINAL_AMOUNT = 'INVOICE_DETAILS_SHOW_TIMECARD_FINAL_AMOUNT',
    INVOICE_EXPENSE_EXTRA_OPTIONS = 'INVOICE_EXPENSE_EXTRA_OPTIONS',
    INVOICE_TIMECARD_EXTRA_OPTIONS = 'INVOICE_TIMECARD_EXTRA_OPTIONS',
    PRESELECT_TC_EXP_MANUAL_INVOICE = 'PRESELECT_TC_EXP_MANUAL_INVOICE',
    INVOICING_INFO_ENABLED = 'INVOICING_INFO_ENABLED',
    INVOICING_CONVERT_BASE_CURRENCY_FROM_PAYMENT_CURRENCY = 'INVOICING_CONVERT_BASE_CURRENCY_FROM_PAYMENT_CURRENCY',
    JOB_POSITION_EXTERNAL_ID_ENABLED = 'JOB_POSITION_EXTERNAL_ID_ENABLED',
    JOB_POSITION_TYPE = 'JOB_POSITION_TYPE',
    LOCALIZED_FIELDS = 'LOCALIZED_FIELDS',
    LOCALIZED_FIELDS_CASES = 'LOCALIZED_FIELDS_CASES',
    LOCALIZED_FIELDS_CONTACTS = 'LOCALIZED_FIELDS_CONTACTS',
    LOCALIZED_FIELDS_INVOICES = 'LOCALIZED_FIELDS_INVOICES',
    MATTER_ACCOUNTING_REVENUE_TYPE = 'MATTER_ACCOUNTING_REVENUE_TYPE',
    MULTI_REVIEW_APPROVE_JOINT_INVOICE = 'MULTI_REVIEW_APPROVE_JOINT_INVOICE',
    MULTIPLE_DRAFT_INVOICES_PER_CASE = 'MULTIPLE_DRAFT_INVOICES_PER_CASE',
    DISCARD_TIMECARDS_EXPENSES_ON_INVOICE = 'DISCARD_TIMECARDS_EXPENSES_ON_INVOICE',
    PAYMENT_CURRENCY_CONVERSION_DATE_CONTROL = 'PAYMENT_CURRENCY_CONVERSION_DATE_CONTROL',
    REMUNERATION_CALC_TYPE_CONTROL = 'REMUNERATION_CALC_TYPE_CONTROL',
    SERVICE_DATE_CONTROL = 'SERVICE_DATE_CONTROL',
    SHOW_DEADLINE_CUSTOM_FIELD_CONTRACT_TABLE = 'SHOW_DEADLINE_CUSTOM_FIELD_CONTRACT_TABLE',
    SHOW_EMPTY_SELECTION = 'SHOW_EMPTY_SELECTION',
    SIGNED_BY_ON_INVOICE_INSTEAD = 'SIGNED_BY_ON_INVOICE_INSTEAD',
    SUB_PRACTICE_AREA = 'SUB_PRACTICE_AREA',
    LAST_HCS_MEETING = 'LAST_HCS_MEETING', // Showing the last effort of the firm's configured type (the EFFORT_ACTIVITY_TYPE value flagged lastEffortValue)
    INVOICE_OFFICE_EMAIL = 'INVOICE_OFFICE_EMAIL',
    USE_CUSTOMIZED_INVOICE_TEMPLATE = 'USE_CUSTOMIZED_INVOICE_TEMPLATE',
    EXCLUDE_VAT_EXEMPT_FROM_DISCOUNT = 'EXCLUDE_VAT_EXEMPT_FROM_DISCOUNT',
    CUSTOM_SERVICE_PERIOD_RECALC_LOGIC = 'CUSTOM_SERVICE_PERIOD_RECALC_LOGIC',
    SORTING_INVOICES = 'SORTING_INVOICES',
    CASE_MERGE_INVOICE_SPEC = 'CASE_MERGE_INVOICE_SPEC',
    PARTY_NUMBER_USAGE = 'PARTY_NUMBER_USAGE',
    PARTY_NUMBER_GENERATION = 'PARTY_NUMBER_GENERATION',
    BULK_SEND_INVOICES = 'BULK_SEND_INVOICES',
    HANDLED_BY_OFFICE_CONTROL = 'HANDLED_BY_OFFICE_CONTROL',
    INVOICE_CORRECTION_FLOW = 'INVOICE_CORRECTION_FLOW',
    SHORT_INVOICE_EXCEL_CR = 'SHORT_INVOICE_EXCEL_CR',
    CORRESPONDENCE_POSTAL_LIST_EXCEL = 'CORRESPONDENCE_POSTAL_LIST_EXCEL',
    CORRESPONDENCE_MODULE = 'CORRESPONDENCE_MODULE',
    INVOICE_DATES_CONTROL_MODAL = 'INVOICE_DATES_CONTROL_MODAL',
    INVOICE_DATES_CONTROL_MODAL_DEBIT = 'INVOICE_DATES_CONTROL_MODAL_DEBIT',
    INVOICE_DATES_CONTROL_MODAL_CREDIT = 'INVOICE_DATES_CONTROL_MODAL_CREDIT',
    INVOICE_DATES_CONTROL_MODAL_PREPAYMENT = 'INVOICE_DATES_CONTROL_MODAL_PREPAYMENT',
    INVOICE_DATES_CONTROL_MODAL_CORRECTION = 'INVOICE_DATES_CONTROL_MODAL_CORRECTION',
    INTEGRATION_TIQ = 'INTEGRATION_TIQ',
    INVOICE_DATE_AUTOUPDATES_CONVERSION_DATES = 'INVOICE_DATE_AUTOUPDATES_CONVERSION_DATES',
    EMPLOYEE_SIGNATURE_FILE = 'EMPLOYEE_SIGNATURE_FILE',
    PARTY_PAYMENT_ACCOUNT_NUMBER = 'PARTY_PAYMENT_ACCOUNT_NUMBER',
    MATTER_CREATION_CLIENTS_ONLY = 'MATTER_CREATION_CLIENTS_ONLY',
    TIMECARD_TWO_DECIMAL_POINTS_DISPLAYMENT = 'TIMECARD_TWO_DECIMAL_POINTS_DISPLAYMENT',
    TIMECARD_TWO_DECIMAL_POINTS_ENTRIES = 'TIMECARD_TWO_DECIMAL_POINTS_ENTRIES',
    HIDE_DONT_NULLIFY_OPTION = 'HIDE_DONT_NULLIFY_OPTION',
    INVOICE_EXTERNAL_APPROVAL = 'INVOICE_EXTERNAL_APPROVAL',
    ZERO_HOURS_ALLOWED_ON_DRAFT_TC = 'ZERO_HOURS_ALLOWED_ON_DRAFT_TC',
    SHOW_PREVIOUS_TIMECARD_ENTRY_IN_TC_FORM = 'SHOW_PREVIOUS_TIMECARD_ENTRY_IN_TC_FORM',
    INVOICE_LISTENER = 'INVOICE_LISTENER',
    CASE_LISTENER = 'CASE_LISTENER',
    CORRECTION_AUTO_VAT_ROUNDING = 'CORRECTION_AUTO_VAT_ROUNDING',
    CASE_DEFAULT_STATUS_OFFER_PENDING = 'CASE_DEFAULT_STATUS_OFFER_PENDING',
    CASE_OFFER_FLOW = 'CASE_OFFER_FLOW',
    AUTOFILL_CASE_NO_OPPONENT = 'AUTOFILL_CASE_NO_OPPONENT',
    GLOBAL_LAW_FIRMS_HUB = 'GLOBAL_LAW_FIRMS_HUB',
    CASE_LOCAL_LANGUAGE_FIELD_FILLED_WITH_CASE_NUMBER = 'CASE_LOCAL_LANGUAGE_FIELD_FILLED_WITH_CASE_NUMBER',
    ADMIN_FEE_MODAL_INVOICES = 'ADMIN_FEE_MODAL_INVOICES',
    CREATE_MULTIAUTHOR_TIMECARD = 'CREATE_MULTIAUTHOR_TIMECARD',
    INVOICE_FIELDS_VALUES_IN_PAYMENT_CURRENCY = 'INVOICE_FIELDS_VALUES_IN_PAYMENT_CURRENCY',
    PARTNER_PEER_GROUP = 'PARTNER_PEER_GROUP',
    MARKETING_PROFILE_PAGE = 'MARKETING_PROFILE_PAGE',
    SHOW_INVOICE_COLUMN_TOTALS_GLOBAL_LIST = 'SHOW_INVOICE_COLUMN_TOTALS_GLOBAL_LIST',
    MY_PORTFOLIO = 'MY_PORTFOLIO',
    PORTFOLIO_SCOPE_SELECTOR = 'PORTFOLIO_SCOPE_SELECTOR',
    INVOICE_SERVICE_RECIPIENT_FIELD = 'INVOICE_SERVICE_RECIPIENT_FIELD',
    EXPENSES_GROUPED_VIEW = 'EXPENSES_GROUPED_VIEW',
    KSEF_INVOICES_LIST = 'KSEF_INVOICES_LIST',
    CHANGE_MATTER_SEQUENCE_NUMBER = 'CHANGE_MATTER_SEQUENCE_NUMBER',
    ACCOUNTING_REPORTS = 'ACCOUNTING_REPORTS',
    INVOICE_DOWNLOAD_XML_E_INVOICE = 'INVOICE_DOWNLOAD_XML_E_INVOICE',
    INVOICE_DOWNLOAD_LEDES_INVOICE = 'INVOICE_DOWNLOAD_LEDES_INVOICE',
    TIMECARD_INCREMENT_CONTROL = 'TIMECARD_INCREMENT_CONTROL',
    TIMECARD_BILLED_TIME_CONTROL = 'TIMECARD_BILLED_TIME_CONTROL',
    REPORTS_MODULE = 'REPORTS_MODULE',
    PORTAL_REPORTS = 'PORTAL_REPORTS',
    LAST_NAME_FIRST = 'LAST_NAME_FIRST',
    TRAININGS_MODULE = 'TRAININGS_MODULE',
    DEBRIEFING_MODULE = 'DEBRIEFING_MODULE',
    PARTY_ASSETS = 'PARTY_ASSETS',
    VACATION_DECLARER = 'VACATION_DECLARER',
    INVOICE_DOWNLOAD_DOCX_FORMAT = 'INVOICE_DOWNLOAD_DOCX_FORMAT',
    NEW_TIMECARDS_WARNING_IGNORE_CURRENT_MONTH = 'NEW_TIMECARDS_WARNING_IGNORE_CURRENT_MONTH',
    TC_MULTIPLIER = 'TC_MULTIPLIER',
    INVOICING_DATE_ON_PARTY_FORM = 'INVOICING_DATE_ON_PARTY_FORM',
    PRIMARY_RECIPIENT_SKIPPED_IF_SPECIFIC_PROVIDED = 'PRIMARY_RECIPIENT_SKIPPED_IF_SPECIFIC_PROVIDED',
    TIMECARD_TEMPLATES = 'TIMECARD_TEMPLATES',
    EXPENSES_NEGATIVE_AMOUNT_ALLOWED = 'EXPENSES_NEGATIVE_AMOUNT_ALLOWED',
    INVOICE_PAYER_CHANGE_KEEPS_RECIPIENTS = 'INVOICE_PAYER_CHANGE_KEEPS_RECIPIENTS',
    EXTERNAL_EMPLOYEE_ID_ON_COLLEAGUE_PROFILE_SOR = 'EXTERNAL_EMPLOYEE_ID_ON_COLLEAGUE_PROFILE_SOR',
    ISSUE_DATE_FIELD_ON_INVOICE = 'ISSUE_DATE_FIELD_ON_INVOICE',
    NDF_EXPORT = 'NDF_EXPORT',
    MATTER_INSIDER_LIST = 'MATTER_INSIDER_LIST',
    DASHBOARD_PROGRESS_TRACKING = 'DASHBOARD_PROGRESS_TRACKING',
    GROUP_SEGMENT_LOCKED = 'GROUP_SEGMENT_LOCKED',
    CONTACT_MERGING = 'CONTACT_MERGING',
    CASE_PREFILL_RP_AS_SP_RM_AS_RL = 'CASE_PREFILL_RP_AS_SP_RM_AS_RL',
    DELEGATION_CONFIDENTIAL_CASES_EXCLUDED = 'DELEGATION_CONFIDENTIAL_CASES_EXCLUDED',
    TIMECARD_NOTES = 'TIMECARD_NOTES',
    LEARNING_MODE = 'LEARNING_MODE',
    NEW_DESIGN = 'NEW_DESIGN',
    CASE_PA_FIELD_SINGLE_SELECTION_ONLY = 'CASE_PA_FIELD_SINGLE_SELECTION_ONLY',
    WEB_TAB_EMPLOYEES = 'WEB_TAB_EMPLOYEES',
    REPORT_WORKING_TIME_BY_EMPLOYEE = 'REPORT_WORKING_TIME_BY_EMPLOYEE',
    SAVE_AS_DRAFT = 'SAVE_AS_DRAFT',
    EMPLOYEE_PRICING = 'EMPLOYEE_PRICING',
    INVOICE_EXCLUDE_FROM_QLIK_SENSE = 'INVOICE_EXCLUDE_FROM_QLIK_SENSE',
    CLIENT_IDENTIFICATION_AND_RISK_ASSESSMENT = 'CLIENT_IDENTIFICATION_AND_RISK_ASSESSMENT',
    RANKINGS_REFEREE = 'RANKINGS_REFEREE',
}
